import { useNavigate } from "react-router-dom"
import { PATH_INFO } from "../util/helper"
import { Button, Flex, Result } from "antd"

export function ErrorPage() {
  const navigate = useNavigate()
  const handleBackHome = () => { navigate(PATH_INFO.COMPANY_LIST.PATH) }

  return (
    <Flex align="center" justify="center" style={{ height: 'calc(100vh - 200px)' }}>
      <Result
        status='error'
        title='エラーが発生しました。'
        extra={
          <Button type='primary' onClick={handleBackHome}>
            ホームに戻る
          </Button>
        }
      />
    </Flex>
  )
}